import { PermissionEnum } from "./DestinationRole"
import { PassengerGroup } from "./PassengerGroup";

export class PassengerGroupUserRole {
    passengerGroupId: number;
    passengerPermission: PermissionEnum;
    transportationPermission: PermissionEnum;
    schedulePermission: PermissionEnum;

    public static fromApi(passengerGroup) {
        const passengerGroupUserRole = new PassengerGroupUserRole();

        passengerGroupUserRole.passengerGroupId = passengerGroup.passengerGroupId;
        passengerGroupUserRole.passengerPermission = passengerGroup.passengerPermission;
        passengerGroupUserRole.transportationPermission = passengerGroup.transportationPermission;
        passengerGroupUserRole.schedulePermission = passengerGroup.schedulePermission;  

        return passengerGroupUserRole;
    }
}

export default PassengerGroupUserRole;
